export const SiteShutdownsTitlePropMap = {
    id: 'PreCog ID',
    country: 'Country',
    state: 'State',
    city: 'City',
    sites: 'Sites',
    status: 'Status',
    start: 'Start',
    end: 'End',
    reasons: 'Reasons',
    shutdownAreas: 'Shutdown Areas',
    duration: 'Duration',
    lastUpdateTime: 'Last Update Time'
};

export const SiteShutdownsPropMap = {
    id: 'preCogId',
    country: 'siteCountry',
    state: 'siteState',
    city: 'siteCity',
    sites: 'siteName',
    status: 'status',
    start: 'startTime',
    end: 'endTime',
    reasons: 'reason',
    shutdownAreas: 'siteType',
    duration: 'duration',
    lastUpdateTime: 'lastUpdateTime'
};
